import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/payment-method"; // Updated API URL for payment methods

  // State for form data, initialized for create or update mode
  const [formData, setFormData] = useState({
    name: "", // Nama Metode Pembayaran
    tax: 0, // Pajak,
    show_pos: false, // Show in POS
    show_reservation: false, // Show in Reservation
  });

  const isUpdateMode = !!initialData; // Check if we are in update mode

  // API hook for create and update
  const { createData: createPaymentMethod, loading: creatingPaymentMethod } =
    useCreateData(API_URL, "paymentMethods");
  const { updateData: updatePaymentMethod, loading: updatingPaymentMethod } =
    useUpdateData(`${API_URL}/${initialData?.id}`, "paymentMethods");

  // Handle form data changes
  const handleChange = useFormChangeHandler(setFormData);

  // Handle form submission
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updatePaymentMethod : createPaymentMethod,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // If initial data is provided (for update), populate the form
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        accountNumber: initialData.accountNumber || "",
        accountName: initialData.accountName || "",
        tax: initialData.tax || 0,
        show_pos: initialData.show_pos || false,
        show_reservation: initialData.show_reservation || false,
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Payment Method Name */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Nama:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Nama Metode Pembayaran"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>
        {/* Tax */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="tax"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Pajak:
          </label>
          <div className="col-sm-8">
            <input
              type="number"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.tax && "is-invalid"
              )}
              id="tax"
              placeholder="Pajak (%)"
              name="tax"
              value={formData.tax}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
            />
            {formError?.tax && (
              <div className="invalid-feedback">{formError.tax}</div>
            )}
          </div>
        </div>
        {/* Show in POS */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="show_pos"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Tampilkan di POS:
          </label>
          <div className="col-sm-8">
            <input
              type="checkbox"
              className="form-check-input"
              id="show_pos"
              name="show_pos"
              checked={formData.show_pos}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
        </div>
        {/* Show in Reservation */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="show_reservation"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Tampilkan di Reservasi:
          </label>
          <div className="col-sm-8">
            <input
              type="checkbox"
              className="form-check-input"
              id="show_reservation"
              name="show_reservation"
              checked={formData.show_reservation}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
          </div>
      </div>

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode
            ? "Update Metode Pembayaran"
            : "Create Metode Pembayaran"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
